import './styles.scss';

export function debounce(func, wait) {
  let timeout;
  return function () {
    const context = this,
      args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      timeout = null;
      func.apply(context, args);
    }, wait);
  };
}

export default function () {
  ('use strict');

  /**
   * CreateHVTSuggestion.
   * @name CreateHVTSuggestion
   * @constructor
   * @this CreateHVTSuggestion
   * @param {object} options
   * @param {object} options.selectors
   * @param {HTMLElement} options.selectors.component - The DOM element.
   * @param {HTMLElement} options.selectors.autocomplete - The DOM element.
   * @param {object} options.classes
   * @param {string} options.classes.input - Input class name.
   * @param {object} options.fbConfig
   * @param {string} options.fbConfig.suggestionUrl - FB suggestion url.
   */

  function CreateHVTSuggestion({ selectors, classes, fbConfig }) {
    this.component = selectors.component ? selectors.component : null;
    this.autocomplete = selectors.autocomplete ? selectors.autocomplete : null;
    this.classes = {
      input: classes.input ? classes.input : null,
      hide: classes.hide ? classes.hide : 'hide',
      link: classes.link ? classes.link : 'search__autocomplete-link',
      submit: classes.submit ? classes.submit : 'search-form__submit',
    };
    this.fbConfig = {
      suggestionUrl: fbConfig.suggestionUrl ? fbConfig.suggestionUrl : null,
    };

    // private settings.
    const setting = {
      inputValue: '',
      suggestions: [],
    };

    // fetch data.
    const makeCall = async (url) => {
      try {
        const request = await fetch(url);
        const response = await request.json();

        return response;
      } catch (e) {
        console.error(e);
      }
    };

    // check if suggestion url provided.
    const checkSuggestionUrl = () => {
      if (!this.fbConfig.suggestionUrl) {
        throw new Error('Missing funnelback suggestion url.');
      }
    };

    // check config.
    const checkConfig = () => {
      checkSuggestionUrl();
    };

    const updateValue = (el, val) => {
      el.setAttribute('value', val);
      el.value = val;
      setting.inputValue = val;
    };

    const submit = (val) => {
      updateValue(this.component.querySelector(`.${this.classes.input}`), val);
      this.component.querySelector('form').submit();
    };

    // get suggestion from funnelback.
    const getAutoCompletion = async () => {
      if (setting.inputValue.length > 2) {
        const url = `${this.fbConfig.suggestionUrl}?partial_query=${setting.inputValue}`;

        const suggestions = await makeCall(url);

        setting.suggestions = suggestions;
        // suggestion
      } else {
        setting.suggestions = [];
      }
    };

    // render auto-completion.
    const renderAutoCompletion = () => {
      const highlight = (qpart, str) =>
        str.replace(new RegExp('(' + qpart + ')', 'gi'), '<strong>$1</strong>');

      const highlightWords = (query, str) =>
        str
          ? query
              .trim()
              .split(' ')
              .reduce((accum, keyword) => highlight(keyword, accum), str)
          : '';

      const autoCompletionItem = () =>
        setting.suggestions
          .map(
            (suggestion) => `
        <li class="search__autocomplete-item">
          <a href="javascript:void(0);" onClick="return searchSubmit('${
            suggestion.disp
          }')" title="${suggestion.disp}" class="${
              this.classes.link
            }">${highlightWords(setting.inputValue, suggestion.disp)}</a>
        </li>
      `
          )
          .join('');

      const autoCompletionList = () =>
        setting.suggestions && setting.suggestions.length > 0
          ? `
        <ul class="search__autocomplete-list">
          ${autoCompletionItem()}
        </ul>
      `
          : '';

      this.autocomplete.innerHTML = autoCompletionList();
    };

    const onInputChange = async (e) => {
      try {
        const currentElement = e.target;

        updateValue(currentElement, currentElement.value);

        await getAutoCompletion();

        renderAutoCompletion();
      } catch (e) {
        console.error(e);
      }
    };

    const hideSuggestions = () => {
      this.autocomplete.classList.add(this.classes.hide);
    };

    const showSuggestions = () => {
      this.autocomplete.classList.remove(this.classes.hide);
    };

    const toggleSuggestions = (e) => {
      if (
        !e.target.classList.contains(this.classes.input) &&
        !e.target.classList.contains(this.classes.submit) &&
        !e.target.classList.contains(this.classes.link)
      ) {
        hideSuggestions();
      } else {
        showSuggestions();
      }
    };

    const bind = () => {
      const searchInput = this.component.querySelector(
        `.${this.classes.input}`
      );
      searchInput.addEventListener('keyup', debounce(onInputChange, 250));

      document.addEventListener('click', toggleSuggestions.bind(this), true);
      document.addEventListener('focus', toggleSuggestions.bind(this), true);

      window.searchSubmit = submit;
    };

    const init = () => {
      checkConfig();
      bind();
    };

    return init();
  }

  const componentSelectors = {
    component: '.js-search',
    autocomplete: '.js-search-autocomplete',
  };

  const findComponents = Array.from(
    document.querySelectorAll(componentSelectors.component)
  );

  if (findComponents.length > 0) {
    findComponents.forEach((component) => {
      return new CreateHVTSuggestion({
        selectors: {
          component: component,
          autocomplete: component.querySelector(
            componentSelectors.autocomplete
          ),
        },
        classes: {
          input: 'search-form__input',
        },
        fbConfig: {
          suggestionUrl: component.getAttribute('data-fb-suggestion'),
        },
      });
    });
  }
}
